<div class="row">
  <div class="col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed">
                <ng-container
                  *ngIf="showLegacy; then legacyDeviceTemplate else regulationDeviceTemplate">
                </ng-container>
                  <ng-template #legacyDeviceTemplate>
                    <tbody>
                      <tr>
                        <th class="col-sm-6">EUDAMED ID</th>
                        <th class="col-sm-6">EUDAMED ID Issuing Agency</th>
                      </tr>
                      <tr>
                        <td [ngClass]="isDefault('Eudamed ID')"><label controlName="eudamedId"></label></td>
                        <td [ngClass]="isDefault('Eudamed ID Issuing Agency')"><label controlName="eudamedIdIssuingAgency"></label></td>
                      </tr>
                    </tbody>
                  </ng-template>
                  <ng-template #regulationDeviceTemplate>
                    <tbody>
                      <tr>
                        <th class="col-sm-6">Primary DI</th>
                        <th class="col-sm-6">Issuing Agency</th>
                      </tr>
                      <tr>
                        <td [ngClass]="isDefault('Primary DI')"><label controlName="udiDI"></label></td>
                        <td [ngClass]="isDefault('Primary DI Issuing Agency')"><label controlName="agency"></label></td>
                      </tr>
                    </tbody>
                  </ng-template>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <ng-container
                    *ngIf="showLegacy; then legacyModelTemplate else regulationModelDeviceTemplate">
                  </ng-container>
                    <ng-template #legacyModelTemplate>
                      <tr>
                        <th class="col-sm-6">EUDAMED DI</th>
                        <th class="col-sm-6">EUDAMED DI Issuing Agency</th>
                      </tr>
                    </ng-template>
                    <ng-template #regulationModelDeviceTemplate>
                      <tr>
                        <th class="col-sm-6">Basic UDI-DI</th>
                        <th class="col-sm-6">Issuing Agency</th>
                      </tr>
                    </ng-template>
                  <tr>
                    <td [ngClass]="isDefault('Basic UDI-DI')">
                      <label controlName="budi"></label>
                    </td>
                    <td [ngClass]="isDefault('Basic UDI-DI Issuing Agency')"><label controlName="bAgency"></label></td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>

          <tr>
            <td class="no-left-padding">
              <table formArrayName="tradeNamesForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Brand or Trade Name(s)</th>
                    <th class="col-sm-6">Language</th>
                  </tr>
                  <ng-container *ngIf="tradeNamesForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let name of tradeNamesForm.controls; let i = index">
                      <td [ngClass]="isDefault('Brand or Trade Name(s)')">
                        <label controlName="value"></label>
                      </td>
                      <td [ngClass]="isDefault('Brand or Trade Name(s)')"> <label controlName="language"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>

            <td class="no-right-padding">
              <table formArrayName="deviceDescriptionForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Description</th>
                    <th class="col-sm-6">Language</th>
                  </tr>
                  <ng-container *ngIf="deviceDescriptionForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let name of deviceDescriptionForm.controls; let i = index">
                      <td class="breakAll" [ngClass]="isDefault('Device Description')"> <label
                          controlName="value"></label></td>
                      <td [ngClass]="isDefault('Device Description')"> <label controlName="language"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Labeler DUNS Number</th>
                    <th class="col-sm-6">Sponsor ID</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Labeler DUNS Number')"><label controlName="labelerDuns"></label></td>
                    <td [ngClass]="isDefault('Sponsor ID')"><label controlName="sponsorId"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Product Name/Generic Name</th>
                    <th class="col-sm-6">URL for Additional Information</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Product Name/Generic Name')">
                      <label
                        controlName="productGenericNames"></label></td>
                    <td [ngClass]="isDefault('URL for Additional Information')">
                     <label
                        controlName="urlForAdditionalInfo"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Class</th>
                    <th class="col-sm-6">Quantity of Device</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Class')"><label controlName="deviceClass"></label></td>
                    <td [ngClass]="isDefault('Quantity of Device')"><label controlName="quantityOfDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Unit of Use DI</th>
                    <th class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Unit of Use DI')"><label controlName="unitOfUseDi"></label></td>
                    <td [ngClass]="isDefault('Unit of Use DI Issuing Agency')"><label
                        controlName="unitOfUseDiAgency"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Version or Model</th>
                    <th class="col-sm-6">Catalog or Reference Number</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Version or Model')"><label controlName="versionOrModel"></label></td>
                    <td [ngClass]="isDefault('Catalog or Reference Number')"><label
                      controlName="referenceOrCatalogNumber"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Software as a Medical Device (SaMD) Version</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Software as a Medical Device')"><label
                        controlName="softwareAsAMedicalDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">EMDN Code(s)</th>
                    <th class="col-sm-6">CND Code</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('EMDN Code')">
                      <table formArrayName="emdnCodesForm">
                        <tbody>
                          <ng-container *ngIf="emdnCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of emdnCodesForm.controls; let i = index">
                              <td><label controlName="emdnCode"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('CND Code')">
                      <table formArrayName="cndCodesForm">
                        <tbody>
                          <ng-container *ngIf="cndCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of cndCodesForm.controls; let i = index">
                              <td><label controlName="cndCode"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">GMDN Code(s)</th>
                    <th class="col-sm-6">FDA Product Code(s) </th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('GMDN Code(s)')">
                      <table formArrayName="GMDNform">
                        <tbody>
                          <ng-container *ngIf="GMDNform.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of GMDNform.controls; let i = index">
                              <td><label controlName="code"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('FDA Product Code')" formArrayName="fdaProductCodesForm">
                      <table>
                        <tbody>
                          <ng-container *ngIf="fdaProductCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of fdaProductCodesForm.controls; let i = index">
                              <td><label controlName="fdaProductCode"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <!-- <tr formGroupName="{{i}}"
                                            *ngFor="let sizeGroup of GMDNform.controls; let i = index">
                                            <td [ngClass]="isDefault('GMDN Code(s)')">
                                                <label controlName="code"></label>
                                            </td>
                                        </tr> -->
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">NMPA Classification Code</th>
                    <th class="col-sm-6">NMPA Original Classification Code</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('NMPA Classification Code')"><label
                        controlName="classificationCode"></label></td>
                    <td [ngClass]="isDefault('NMPA Original Classification Code')"><label
                        controlName="originalClassificationCode"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table formArrayName="diDataCarrierTypesForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th>DI Data Carrier Type</th>
                  </tr>
                  <ng-container *ngIf="diDataCarrierTypesForm.controls.length; else emptyTemplate1field">
                    <tr formGroupName="{{i}}" *ngFor="let code of diDataCarrierTypesForm.controls; let i = index">
                      <td [ngClass]="isDefault('DI Data Carrier Type')"><label controlName="value"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>


          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-3">Has Direct Marking DI?</th>
                    <th class="col-sm-4">Is Direct Marking DI same as Primary DI?</th>
                    <th class="col-sm-5">Device Subject to Direct Marking (DM), but Excepted?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Has Direct Marking DI?')"><label controlName="hasDirectMarking"></label>
                    </td>
                    <td [ngClass]="isDefault('Is Direct Marking DI same as Primary DI?')"><label
                        controlName="isDirectMarkingDiSameAsPrimaryDi"></label></td>
                    <td [ngClass]="isDefault('Device Subject to Direct Marking (DM), but Excepted?')"><label
                        controlName="directMarkingExempt"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Direct Marking DI</th>
                    <th class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Direct Marking DI')"><label controlName="directMarkingDI"></label></td>
                    <td [ngClass]="isDefault('Direct Marking DI Issuing Agency')"><label
                        controlName="directMarkingDIAgency"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>


          <tr>
            <td class="no-left-padding">
              <table formArrayName="secondaryDiForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Secondary DI</th>
                    <th class="col-sm-6">Secondary DI Issuing Agency</th>
                  </tr>
                  <ng-container *ngIf="secondaryDiForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of secondaryDiForm.controls; let i = index">
                      <td [ngClass]="isDefault('Secondary DI')"><label controlName="diValue"></label></td>
                      <td [ngClass]="isDefault('Secondary DI')"><label controlName="diAgency"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding">
              <table formArrayName="previousDiForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Previous DI</th>
                    <th class="col-sm-6">Previous DI Issuing Agency</th>
                  </tr>
                  <ng-container *ngIf="previousDiForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of previousDiForm.controls; let i = index">
                      <td [ngClass]="isDefault('Previous DI')"><label controlName="diValue"></label></td>
                      <td [ngClass]="isDefault('Previous DI')"><label controlName="diAgency"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Production Identification Controlled By:</th>
                    <th class="col-sm-6"></th>
                  </tr>
                  <tr>
                    <td>Expiration Date?</td>
                    <td [ngClass]="isDefault('Controlled by Expiration Date?')"><label
                        controlName="isExpirationDate"></label></td>
                  </tr>
                  <tr>
                    <td>Manufacturing Date?</td>
                    <td [ngClass]="isDefault('Controlled by Manufacturing Date?')"><label
                        controlName="isManufacturingDate"></label></td>
                  </tr>
                  <tr>
                    <td>Lot or Batch Number?</td>
                    <td [ngClass]="isDefault('Controlled by Lot or Batch Number?')"><label
                        controlName="isLotOrBatchNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Serial Number?</td>
                    <td [ngClass]="isDefault('Controlled by Serial Number?')"><label
                        controlName="isSerialNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Donation Identification Number?</td>
                    <td [ngClass]="isDefault('Controlled by Donation Identification Number?')"><label
                        controlName="controlledByDonationIdentificationNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Software Version?</td>
                    <td [ngClass]="isDefault('Controlled By Software Version?')"><label
                        controlName="isSwVersion"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
